import { api } from "@/api/client";

export interface InstituicaoHealthScore {
  id: number;
  codigo: string;
  nome: string;
  healthScore: number;
}

export async function getListaHealthScore(): Promise<InstituicaoHealthScore[]> {
  const { data } = await api.get<InstituicaoHealthScore[]>("relatorio/HealthScore/ListaSimples");
  return data;
}
